

import React, { useEffect, useState } from 'react';
import { notification, Spin, Button, Rate, Switch } from 'antd';
import { orderBy } from 'lodash';
import moment from 'moment';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import ShareCampaignModal from '../../shared/ShareCampaignModal';
import ReviewCampaignModal from './ReviewCampaignModal';

const CampaignDetails = (props) => {
	const { campaignDetails, user } = props;
	const [isSwitchEnabled, setSwitch] = useState(false);
	const [isDonationsViewExpanded, setDonationsViewExpanded] = useState(false);
	const [isCommentsViewExpanded, setCommentsViewExpanded] = useState(false);
	const [isDonationsSorted, setDonationSort] = useState(false);
	const [comment, setComment] = useState('');
	const [isShareModalVisible, setShareModalVisibility] = useState(false);
	const [isReviewsModalVisible, setReviewModalVisibility] = useState(false);
	const [isDescriptionExpanded, setDescriptionExpansion] = useState(false);
	const [isReviewsExpanded, setReviewsExpansion] = useState(false);

	const { comments, reviews, campaign, loading, loadingForRecentCauses } = campaignDetails || {};

	const { recentCauses } = campaignDetails || [];
	const { match, location, history, getRecentCauses, anonymosulyPostCommentForCampaign, postCommentForCampaign, getReviewsForCampaigns, getCommentsForCampaigns, getCampaignDetails } = props;
	const { campaign_info } = campaign || {};

	const { campaignDetails: campaignDetail, donations, userDetails } = campaign_info || {};
	const { donations: actualDonations } = donations || {};

	const { weeks_left, shares, supporters, cover_photo, funded, amount, title, id, progress, story, short_story } = campaignDetail || {};

	const { first_name, last_name, avatar, address } = userDetails || {};
	const { params } = match || {};
	const campaignId = params && params.id ? Number(params.id) : null;

	const formattedShortStory = story ? ((story.length >= 100 && (!isDescriptionExpanded)) ? `${story.substring(0, 100)}...` : story) : 'N/A';
	let campaignCoverPhoto = '/images/Trending-img-2.png';
	let authorAvatar = '/images/user-icon.png';
	if (cover_photo) {
		campaignCoverPhoto = `${process.env.REACT_APP_BACKEND_BASE_URL}${cover_photo}`;
	}
	if (avatar) {
		authorAvatar = `${process.env.REACT_APP_BACKEND_BASE_URL}${avatar}`;;
	}
	let formattedDonations = actualDonations || [];
	let formattedComments = comments || [];
	let formattedReviews = reviews || [];

	if (isDonationsSorted) {
		formattedDonations = orderBy(formattedDonations, ({ amount }) => Number(amount), ['desc']);
	}

	if (!isDonationsViewExpanded) {
		formattedDonations = formattedDonations && formattedDonations.length && formattedDonations.filter((donation, index) => index <= 4);
	}
	if (!isCommentsViewExpanded) {
		formattedComments = formattedComments && formattedComments.length && formattedComments.filter((comments, index) => index <= 3);
	}
	if (!isReviewsExpanded) {
		formattedReviews = formattedReviews && formattedReviews.length && formattedReviews.filter((reviews, index) => index <= 3);
	}
	useEffect(() => {
		if (campaignId) {
			getCampaignDetails(campaignId).then(({ payload }) => {
				const { campaign } = payload || {};
				const { campaign_info } = campaign || {};
				const { campaignDetails } = campaign_info || {};
				const { category } = campaignDetails || {};
				getRecentCauses(category, campaignId);
			})
			getCommentsForCampaigns(campaignId);
			getReviewsForCampaigns(campaignId);
		} else {
			notification.error({
				message: 'GET CAMPAIGN DETAILS',
				description: 'CampaignId is not valid'
			})
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return (
		<div>
			<Spin spinning={loading}>
				<section className="pledge-of-the-day bg-white campaignSec1">
					<div className="container">
						<div className="row">
							<div className="col-lg-7 col-md-12 col-sm-12">
								<div className="campaignSec1-left-img">
									<img className="img-fluid w-100 mb-4 mb-md-0" src={campaignCoverPhoto} alt="" />
								</div>
								<div className="campaignSec1-left">
									<p className="case">CAUSE NO {id}</p>
									<p className="title">{title}</p>
									<div className="progress-outer-wrap">
										<div className="progres progress-wrap">
											<div className="progress-inner">
												<div className="progress-bar" role="progressbar" style={{ width: progress }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
											</div>
										</div>
										<div className="progress-info">
											<h4><span>Raised:</span>${funded}</h4>
											<h4><span>Goal:</span>${amount}</h4>
										</div>
									</div>
									<div className="campaign-detail">
										<p className="quote">“{short_story}”</p>
										<p>{formattedShortStory}</p>
										{
											formattedShortStory && formattedShortStory.length && formattedShortStory.length >= 100 &&
											<button onClick={() => setDescriptionExpansion(!isDescriptionExpanded)} style={{ border: '0px solid', background: 'none' }} className="readmore">
												{isDescriptionExpanded ? 'Read Less' : 'Read More'}
												<i className={isDescriptionExpanded ? 'fa fa-arrow-circle-up' : 'fa fa-arrow-circle-down'}></i>
											</button>
										}
										<div className="author">
											<div className="desc">
												<div className="img">
													<img className="" src={authorAvatar} alt="author" />
												</div>
												<div className="name">
													<p>By {`${first_name} ${last_name}`}</p>
													<p>{address}</p>
												</div>
											</div>
											<div className="socials">
												<ul>
													<li><p>Share</p></li>
													<li><a href="#!"><i className="fa fa-facebook"></i></a></li>
													<li><a href="#!"><i className="fa fa-twitter"></i></a></li>
													<li><a href="#!"><i className="fa fa-google-plus"></i></a></li>
													<li><a href="#!"><i className="fa fa-envelope-o"></i></a></li>
												</ul>
											</div>
										</div>
									</div>
									<div className="comments-wrap">
										<p className="title">Comments <span>({comments && comments.length ? comments.length : 0})</span></p>
										<form>
											<ul className="list-unstyled">
												<li className="media mb-4">
													<div className="icon">
														<img src="/images/user-icon-2.png" alt="icon" className="img-fluid" />
													</div>
													<div className="media-body">
														<input type="text" value={comment} className="form-control" onChange={({ target }) => setComment(target.value)} placeholder="Write your comment here" />
													</div>
												</li>
											</ul>
											<div className="form-row align-items-center">
												<div className="form-group col-sm-6 pl-0">
													<div className="custom-control custom-switch">
														{/* <input type="checkbox" className="custom-control-input" id="customSwitch1" defaultChecked="" /> */}
														<div>
															<Switch onChange={() => setSwitch(!isSwitchEnabled)} checked={isSwitchEnabled} />
															<span style={{ fontSize: 16, marginLeft: 10 }}>
																Post anonymously
															</span>
														</div>
														{/* <label className="custom-control-label" htmlFor="customSwitch1">Post anonymously</label> */}
													</div>
												</div>
												<div className="form-group col-sm-6 text-right">
													<Button
														onClick={() => {
															if ((user && user.id) && (!isSwitchEnabled)) {
																postCommentForCampaign(campaignId, comment).then(() => {
																	getCommentsForCampaigns(campaignId);
																	setComment('');
																});
															} else if (!isSwitchEnabled) {
																notification.warning({
																	message: 'POST COMMENT',
																	description: 'You need to login to continue'
																})
																history.push({
																	pathname: '/auth/login',
																	state: { redirectUrl: location.pathname }
																});
															} else if (isSwitchEnabled) {
																anonymosulyPostCommentForCampaign(campaignId, comment).then(() => {
																	getCommentsForCampaigns(campaignId);
																	setComment('');
																	setSwitch(false);
																});
															}
														}}
														style={{ color: 'white' }}
														disabled={!(comment.length)}
														className="btn btn-success px-4 post-btn">
														Post comment
													</Button>
												</div>
											</div>
										</form>
										<ul style={comments && comments.length && comments.length > 4 ? { height: '534px', overflowY: 'auto' } : {}} className="list-unstyled older-comments">
											{
												formattedComments && formattedComments.length ? formattedComments.map(({ userName, body, created_at, avatar }, index) => {
													let cover = '/images/user-icon-2.png';
													if (avatar) {
														cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${avatar}`;
													}
													return <li key={index} className="media">
														<div className="icon">
															<img src={cover} alt="icon" className="img-fluid" />
														</div>
														<div className="media-body">
															<h6 className="mt-0 mb-3">{userName} - <span>{moment(created_at).fromNow()}</span></h6>
															<p className="mb-2">{body}</p>
														</div>
													</li>;
												}) : ''
											}
										</ul>
										{
											comments && comments.length && comments.length > 4 ?
												<div className="text-center">
													<button type="button" onClick={() => setCommentsViewExpanded(!isCommentsViewExpanded)} className="view-more">
														{isCommentsViewExpanded ? 'VIEW LESS' : 'VIEW MORE'}
													</button>
												</div> : ''
										}
									</div>
								</div>
							</div>
							<div className="col-lg-5 col-md-12 col-sm-12">
								<div className="campaignSec1-text">
									<div className="btns-wrap">
										<button onClick={() => history.push(`/donate-money/${id}`)} type="button" className="btn-success">
											<img src="/images/donate-icon.png" alt="icon" className="img-fluid" />
											DONATE NOW
										</button>
										<button onClick={() => setShareModalVisibility(true)} type="button" className=""><img src="/images/share-icon.png" alt="icon" className="img-fluid" />SHARE</button>
									</div>
									<div className="donation-info-wrap">
										<div className="donation-info-box">
											<h3>${funded} raised</h3>
											<h4>of ${amount} goal</h4>
										</div>
										<ul className="donation-stats-box">
											<li>
												<h4>{supporters}</h4>
												<h5>Supporter</h5>
											</li>
											<li>
												<h4>{shares}</h4>
												<h5>Shares</h5>
											</li>
											<li>
												<h4>{weeks_left > 0 ? weeks_left : 0}</h4>
												<h5>Weeks Left</h5>
											</li>
										</ul>
										<div className="people-donated-box">
											<div className="head">
												<h6>People just donated <span>({actualDonations && actualDonations.length ? actualDonations.length : 0})</span></h6>
											</div>
											<div style={actualDonations && actualDonations.length && actualDonations.length > 5 ? { height: '473px', overflowY: 'auto' } : {}} className="box-body">
												<ul className="nav nav-tabs" id="donationTab" role="tablist">
													<li onClick={() => setDonationSort(false)} className="nav-item" role="presentation">
														<a className="nav-link active" id="all-tab" data-toggle="tab" href="#all" role="tab" aria-controls="all" aria-selected="true">All</a>
													</li>
													<li onClick={() => setDonationSort(true)} className="nav-item" role="presentation">
														<a className="nav-link" id="top-tab" data-toggle="tab" href="#top" role="tab" aria-controls="top" aria-selected="false">Top Donations</a>
													</li>
												</ul>
												<div className="tab-content" id="donationTabContent">
													<div className="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
														<ul>
															{
																formattedDonations && formattedDonations.length ?
																	formattedDonations.map(({ name, created_at, amount, avatar }, index) => {
																		let cover = '/images/user-icon.png';
																		if (avatar) {
																			cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${avatar}`;
																		}
																		return (
																			<li key={index}>
																				<div className="name"><img style={{ height: '34px', width: '34px' }} src={cover} alt="icon" className="img-fluid" /><p>{`${name || ''}`}</p></div>
																				<div className="price"><p>${amount} - <span>{moment(created_at).fromNow()}</span></p></div>
																			</li>
																		);
																	}) : ''
															}
														</ul>
														{
															actualDonations && actualDonations.length && actualDonations.length > 5 ?
																<div className="text-center">
																	<button type="button" onClick={() => setDonationsViewExpanded(!isDonationsViewExpanded)} className="view-more">
																		{isDonationsViewExpanded ? 'VIEW LESS' : 'VIEW MORE'}
																	</button>
																</div> : ''
														}
													</div>
													<div className="tab-pane fade" id="top" role="tabpanel" aria-labelledby="top-tab">
														<ul>
															{
																formattedDonations && formattedDonations.length ?
																	formattedDonations.map(({ name, amount, id, avatar }, index) => {
																		return (
																			<li key={index}>
																				<div className="name"><img src="/images/user-icon.png" alt="icon" className="img-fluid" /><p>{name}</p></div>
																				<div className="price"><p>${amount} -<span>1 hr</span></p></div>
																			</li>
																		);
																	}) : ''
															}
														</ul>
														{
															actualDonations && actualDonations.length && actualDonations.length > 4 ?
																<div className="text-center">
																	<button type="button" onClick={() => setDonationsViewExpanded(!isDonationsViewExpanded)} className="view-more">
																		{isDonationsViewExpanded ? 'VIEW LESS' : 'VIEW MORE'}
																	</button>
																</div> : ''
														}
													</div>
												</div>
											</div>
										</div>
										<div className="people-commented-box">
											<div className="head">
												<h6>
													People Reviews
													<span>({reviews && reviews.length ? reviews.length : 0})</span>
													<button onClick={() => setReviewModalVisibility(true)} style={{ float: 'right' }} type="button" className="view-more">
														ADD
													</button>
												</h6>
											</div>
											<div className="box-body">
												<ul style={reviews && reviews.length && reviews.length > 4 ? { height: '534px', overflowY: 'auto' } : {}}>
													{
														formattedReviews && formattedReviews.length ?
															formattedReviews.map(({ rating, text, title, avatar, created_at, from }, index) => {
																let cover = '/images/user-icon-2.png';
																if (avatar) {
																	cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${avatar}`;
																}
																return (
																	<li key={index}>
																		<div className="img">
																			<img src={cover} alt="icon" className="img-fluid" />
																		</div>
																		<div className="text">
																			<h5>{from} - <span>{moment(created_at).fromNow()}</span></h5>
																			<div className="rating">
																				<Rate disabled value={rating} />
																			</div>
																			<p className="bold">{title}</p>
																			<p>{text}</p>
																		</div>
																	</li>
																);
															}) : ''
													}
												</ul>
												{
													reviews && reviews.length && reviews.length > 4 ?
														<div className="text-center">
															<button onClick={() => setReviewsExpansion(!isReviewsExpanded)} type="button" className="view-more">
																{isReviewsExpanded ? 'VIEW LESS' : 'VIEW MORE'}
															</button>
														</div> : ''
												}

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="trending-causes bg-gray campaignSec2">
					<div className="container">
						<h3 className="main-heading text-center sm-title">Help them for hapiness!</h3>
						<h2 className="main-heading text-center bg-title">Recent Causes</h2>
						<Spin spinning={loadingForRecentCauses}>
							{
								recentCauses && recentCauses.length ?
								<OwlCarousel className="owl-carousel owl-theme campaignTrendingCards" margin={2} dots={false} responsive={{ 0: { items: 1 }, 480: { items: 2 }, 768: { items: 3 } }} nav={false}>
									{
										recentCauses.map(({ id, story, cover_photo: coverPhoto, address, end_date, deadline, title, progress, amount }, index) => {
											const daysGone = deadline ? `${Math.abs(moment(deadline).diff(moment(), 'days'))} days left` : 'N/A';
											const formattedAddress = address ? (address.length >= 35 ? `${address.substring(0, 30)}...` : address) : 'N/A';
											const formattedStory = story ? (story.length >= 40 ? `${story.substring(0, 40)}...` : story) : 'N/A';
											const formattedTitle = title ? (title.length >= 25 ? `${title.substring(0, 23)}...` : title) : 'N/A';
											let cover = '/images/become-partner-4-img-1.png';
											if (coverPhoto) {
												cover = `${process.env.REACT_APP_BACKEND_BASE_URL}${coverPhoto}`;
											}
											return <div key={index} className="card trending-cause-card">
												<div className="img">
													<img src={cover} className="img-fluid" alt="" />
													<a href={`/donate-money/${id}`} style={{ textAlign: 'center', paddingTop: 14 }} className="donate-btn">DONATE NOW</a>
												</div>
												<div className="desc">
													<div className="text-card"> <span>{formattedAddress}</span> <span>{daysGone}</span> </div>
													<a style={{ color: 'black' }} href={`/campaign-details/${id}`}>
														<h1>{formattedTitle}</h1>
														<p>{formattedStory}</p>
														<div className="text-card m-0"> <span>Last donation</span> <span>{end_date ? moment(end_date).fromNow() : ''}</span> </div>
														<div className="progres">
															<div className="progress-inner">
																<div className="progress-bar" role="progressbar" style={{ width: `${progress || 0}` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
															</div>
															<div className="treanding-cause-bottom">
																<h4 className="left-text-s"><span>Raised</span>${amount}</h4>
																<h4 className="left-right-s">{progress}</h4>
															</div>
														</div>
													</a>
												</div>
											</div>
										})
									}
								</OwlCarousel> : ''
							}
						</Spin>
					</div>
				</section>
			</Spin>
			<ShareCampaignModal
				{...props}
				isShareModalVisible={isShareModalVisible}
				setShareModalVisibility={setShareModalVisibility}
			/>
			<ReviewCampaignModal
				{...props}
				campaignId={campaignId}
				isReviewsModalVisible={isReviewsModalVisible}
				setReviewModalVisibility={setReviewModalVisibility}
			/>
		</div>
	);
};

export default CampaignDetails;
